// <p> with nothing (or only whitespace) between the tags.
const EMPTY_PARAGRAPH_RE = /(<p\b[^>]*>)\s*(<\/p>)/gi

/**
 * Give empty <p> elements a &nbsp; so they render as the blank line the analyst
 * saw in the rich text editor.
 *
 * The editor emits every paragraph with an inline `margin: 0`, so the only way
 * to put a gap between paragraphs is an empty one -- and that is what the
 * templates contain (`<p style="margin: 0px;"></p>`). Inside the editor those
 * look like blank lines because ProseMirror injects a placeholder <br> into the
 * DOM, but that placeholder never reaches the saved HTML. An empty block with no
 * content and no margin has zero height, so the gaps vanish anywhere the saved
 * HTML is rendered directly -- a v-html preview as much as a mail client.
 *
 * Mirrors fill_empty_paragraphs() in services/view_set_service.py, which does
 * the same normalization on the rendered/sent side. Idempotent, and leaves
 * paragraphs that already hold a <br> or &nbsp; alone.
 */
export function fillEmptyParagraphs(html) {
  if (!html) return html
  return html.replace(EMPTY_PARAGRAPH_RE, '$1&nbsp;$2')
}

/**
 * Point an email body's cid: image references (signature/logo) at real URLs, the
 * way a mail client resolves the inline parts sent with it. `images` is the
 * { signature, logo, logo_2 } map the API returns as inline_images; a missing
 * or null entry leaves its reference alone.
 *
 * logo_2 goes before logo so "cid:logo" doesn't partially match "cid:logo_2".
 */
export function resolveInlineImages(html, images) {
  if (!html) return html
  const imgs = images || {}
  let out = html
  if (imgs.logo_2) out = out.replaceAll('cid:logo_2', imgs.logo_2)
  if (imgs.logo) out = out.replaceAll('cid:logo', imgs.logo)
  if (imgs.signature) out = out.replaceAll('cid:signature', imgs.signature)
  return out
}

/** A stored email body as it should render: images resolved, blank lines kept. */
export function renderEmailBody(html, images) {
  return fillEmptyParagraphs(resolveInlineImages(html || '', images))
}
